import React from 'react';
import { Box, Typography } from '@mui/material';

import { ReactComponent as Decor } from '../../../../assets/clan/clanTrophies/cups_bg.svg';

const Cup = ({
    bgColor,
    cupSvg: CupSvg,
    text,
    value,
}: {
    bgColor: string;
    cupSvg: React.FunctionComponent;
    text: string;
    value: number | undefined;
}) => {
    return (
        <Box width={'100%'}>
            <Box
                sx={{
                    height: '231px',
                    display: 'flex',
                    backgroundColor: bgColor + '10',
                    borderRadius: '20px',
                    justifyContent: 'center',
                    overflow: 'hidden',
                    position: 'relative',
                }}
            >
                <Box
                    sx={{
                        position: 'absolute',
                        '& path': {
                            fill: bgColor,
                            stroke: bgColor,
                        },
                    }}
                >
                    <Decor></Decor>
                </Box>
                <Box
                    sx={{
                        marginTop: '40px',
                        textAlign: 'center',
                    }}
                >
                    <CupSvg></CupSvg>
                    <Typography
                        sx={{
                            color: '#0F0E0E40',
                            fontFamily: 'AvenirNext400',
                            fontSize: '14px',
                            marginTop: '30px',
                        }}
                    >
                        {text}
                    </Typography>
                    <Typography
                        sx={{
                            color: '#0F0E0E',
                            fontFamily: 'AvenirNext700',
                            fontSize: '24px',
                        }}
                    >
                        {value ?? 0}
                    </Typography>
                </Box>
            </Box>
        </Box>
    );
};

export default Cup;
